import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ntxAPI } from '../../../API/axiosNeatex';
import type { PosRegistrationModel } from './PosModels';
import type { APIResponse } from '../../Shared/shared';

export const addPosRegistration = createAsyncThunk(
  'PosCashier/addPosRegistration',
  async (item: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await ntxAPI.post<APIResponse<string>>('Pos/AddPosRegistration', item);

      if (data.succeeded) {
        // تأكد من انتظار تحديث الكاشيرات بعد الإضافة
        // await dispatch(GetPosCashersByPosId(item.posId));
        return data;
      } else {
        // في حالة فشل الـ API إعادة رسالة الخطأ
        return rejectWithValue(data.message || 'An unknown error occurred.');
      }
    } catch (error: any) {
      // معالجة الاستثناءات العامة
      const errorMessage =
        error.response?.data?.message || error.message || 'An error occurred while adding the cashier.';
      return rejectWithValue(errorMessage);
    }
  }
);
export const updatePosRegistration = createAsyncThunk(
  'PosRegistration/updatePosRegistration',
  async (item: PosRegistrationModel, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await ntxAPI.post<APIResponse<PosRegistrationModel>>('Pos/UpdatePosRegistration', item);

      if (data.succeeded) {
        // تأكد من انتظار تحديث الكاشيرات بعد الإضافة
        // await dispatch(GetPosCashersByPosId(item.posId));
        return data;
      } else {
        // في حالة فشل الـ API إعادة رسالة الخطأ
        return rejectWithValue(data.message || 'An unknown error occurred.');
      }
    } catch (error: any) {
      // معالجة الاستثناءات العامة
      const errorMessage =
        error.response?.data?.message || error.message || 'An error occurred while adding the cashier.';
      return rejectWithValue(errorMessage);
    }
  }
);

export const getPosRegistrationById = createAsyncThunk(
  'PosRegistration/getPosRegistrationById',
  async (Id: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get<APIResponse<PosRegistrationModel>>(`Pos/GetPosRegistrationById?Id=${Id}`);
      if (data.succeeded) {
        return data.data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getPosRegistrationListByPosId = createAsyncThunk(
  'PosRegistration/getPosRegistrationListByPosId',
  async (posId: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get<APIResponse<PosRegistrationModel[]>>(
        `Pos/GetPosRegistrationListByPosId?PosId=${posId}`
      );
      if (data.succeeded) {
        return data.data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const approvePosRegistration = createAsyncThunk(
  'PosCashier/approvePosRegistration',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post<APIResponse<any>>('Pos/ApprovePosRegistration', item);

      if (data.succeeded) {
        return data;
      } else {
        return rejectWithValue(data.message || 'An unknown error occurred.');
      }
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || error.message || 'An error occurred while adding the cashier.';
      return rejectWithValue(errorMessage);
    }
  }
);
export const deletePosRegistration = createAsyncThunk(
  'PosCashier/deletePosRegistration',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post<APIResponse<boolean>>('Pos/DeletePosRegistration', item);

      return data;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || error.message || 'An error occurred while adding the cashier.';
      return rejectWithValue(errorMessage);
    }
  }
);

const initialState = {
  PosRegistrationByPosId: [] as PosRegistrationModel[],
  PosRegistrationById: {} as PosRegistrationModel,
  loading: false,
  error: null as string | null
};

const PosRegistrationSlice = createSlice({
  name: 'PosRegistration',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getPosRegistrationListByPosId.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPosRegistrationListByPosId.fulfilled, (state, action: PayloadAction<PosRegistrationModel[]>) => {
        state.loading = false;
        state.PosRegistrationByPosId = action.payload;
      })
      .addCase(getPosRegistrationListByPosId.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })
      //~~~~~~~~
      .addCase(getPosRegistrationById.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPosRegistrationById.fulfilled, (state, action: PayloadAction<PosRegistrationModel>) => {
        state.loading = false;
        state.PosRegistrationById = action.payload;
      })
      .addCase(getPosRegistrationById.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export default PosRegistrationSlice.reducer;
